module.exports = __webpack_public_path__ + "img/ZX-01.7df0d6ad.png";